import axios from "axios";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Form } from "react-bootstrap";
import apiUrls from "../../../Api/MainApi";
import "./index.css";
import { MDBInput, MDBTextArea } from 'mdb-react-ui-kit';
import { DatePicker, Select } from "antd";
import moment from "moment";
import debounce from 'lodash.debounce';

const BasicInfoForm = ({ formData, setFormData, setIsFormValid }) => {
  const [showEmptyFieldsMessage, setShowEmptyFieldsMessage] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [GenderOptions, setGenderOptions] = useState([]);
  const [StateOptions, setStateOptions] = useState([]);
  const [CityOptions, setCityOptions] = useState([]);
  const [PincodeOptions, setPincodeOptions] = useState([]);
  const [searchTextState, setSearchTextState] = useState("");
  const [searchTextCity, setSearchTextCity] = useState("");
  const [searchTextPincode, setSearchTextPincode] = useState("");
  const [StateID, setStateID] = useState(0);
  const [CityID, setCityID] = useState(0);
  const AddressInputRef = useRef(null);
  const currentYear = moment().year();
  const minDOB = moment().subtract(80, "years"); // 80 years ago from now
  const maxDOB = moment().subtract(18, "years"); // 18 years ago from now
  const debouncedSetSearchTextState = useCallback(debounce(setSearchTextState, 300), []);
  const debouncedSetSearchTextCity = useCallback(debounce(setSearchTextCity, 300), []);
  const debouncedSetSearchTextPincode = useCallback(debounce(setSearchTextPincode, 300), []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pospID = sessionStorage.getItem('pospid');
        const response = await axios.post(apiUrls.GetPOSPRequestMaster, { pospID });

        const data = response?.data?.data;
        console.log(response, "fhgffh")
        setFormData(prevData => ({
          ...prevData,
          Fname: data?.fname || '',
          Lname: data?.lname || '',
          MobileNo: data?.mobileNo || '',
          EmailID: data?.emailID || '',
          POSPID: pospID || ''
          // StateID:
        }));

        if (data?.pincode) {
          const responseState = await axios.post(apiUrls.GetStateCityPincodeByPincodeID, { PincodeID: Number(data.pincode) });
          console.log("responseState",responseState)
          setFormData(prevData => ({
            ...prevData,
            Fname: data?.fname || '',
            Lname: data?.lname || '',
            MobileNo: data?.mobileNo || '',
            EmailID: data?.emailID || '',
            POSPID: pospID || '',
            State:responseState.data.data.stateID,
            City:responseState.data.data.cityID,
            Pincode:Number(data.pincode),
          }));
          
          setCityID(responseState.data.data.cityID);
          setStateID(responseState.data.data.stateID);
        }

        // setCityID(formData.City);
        // setStateID(formData.State);
      } catch (error) {
        console.error('Error fetching POSP data:', error);
      }
    };
    fetchData();
  }, [setFormData]);
  
  const disabledDate = (current) => {
    return current && (current.isAfter(maxDOB) || current.isBefore(minDOB));
  };
  const handleDateChange = (date, dateString) => {
    setFormData(prevData => ({
      ...prevData,
      DOB: dateString ? moment(dateString).format('YYYY-MM-DD') : ''
    }));
    validateField("DOB", dateString);
  };

  useEffect(() => {
    const fetchGenderOptions = async () => {
      try {
        const response = await axios.get(apiUrls.GetGenderDropDown);
        setGenderOptions(response.data.data || []);
      } catch (error) {
        console.error('Error fetching Gender options:', error);
      }
    };
    fetchGenderOptions();
  }, []);

  useEffect(() => {
    const fetchStateOptions = async () => {
      try {
        const response = await axios.post(apiUrls.GetStateDropDown, { SearchText: searchTextState });
        setStateOptions(response.data.data || []);
      } catch (error) {
        console.error('Error fetching State options:', error);
      }
    };
    fetchStateOptions();
  }, []);

  useEffect(() => {
    const fetchCityOptions = async () => {
      if (StateID > 0) {
        try {
          const response = await axios.post(apiUrls.GetCityDropDown, { id: StateID, SearchText: searchTextCity });
          setCityOptions(response.data.data || []);
        } catch (error) {
          console.error('Error fetching City options:', error);
        }
      }
    };
    fetchCityOptions();
  }, [StateID, searchTextCity]);

  useEffect(() => {
    const fetchPincodeOptions = async () => {
      if (StateID > 0 && CityID > 0) {
        try {
          const response = await axios.post(apiUrls.GetPincodeDropDown, { StateID: StateID, CityID: CityID, SearchText: searchTextPincode });
          setPincodeOptions(response.data.data || []);
          console.log("pincode",response)
        } catch (error) {
          console.error('Error fetching Pincode options:', error);
        }
      }
    };
    fetchPincodeOptions();
  }, [StateID, CityID, searchTextPincode]);

  const handleStateChange = (value) => {
    setStateID(value);
    setFormData(prevData => ({
      ...prevData,
      State: value,
      City: '',
      Pincode: ''
    }));
    setSearchTextState('');
  };

  const handleCityChange = (value) => {
    setCityID(value);
    setFormData(prevData => ({
      ...prevData,
      City: value,
      Pincode: ''
    }));
    setSearchTextCity('');
  };

  const handlePincodeChange = (value) => {
    setFormData(prevData => ({
      ...prevData,
      Pincode: value
    }));
    setSearchTextPincode('');
  };

  const handleSearchState = (value) => {
    debouncedSetSearchTextState(value);
  };

  const handleSearchCity = (value) => {
    debouncedSetSearchTextCity(value);
  };

  const handleSearchPincode = (value) => {
    debouncedSetSearchTextPincode(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
    setShowEmptyFieldsMessage(false);
    validateField(name, value);
  };

  const validateDOB = (dob) => {
    const age = moment().diff(moment(dob, "YYYY-MM-DD"), 'years');
    return age >= 18;
  };

   // Initialize formData.DOB with the default date (18 years ago)
   useEffect(() => {
    if (!formData.DOB) {
      setFormData(prevData => ({
        ...prevData,
        DOB: maxDOB.format('YYYY-MM-DD')
      }));
    }
  }, [formData.DOB, setFormData]);
  const validateField = (name, value) => {
    if (name === "DOB" && !validateDOB(value)) {
      setFieldErrors(prevErrors => ({ ...prevErrors, [name]: "You must be at least 18 years old." }));
      setIsFormValid(false);
      return false;
    }

    if (value.trim() === "") {
      setFieldErrors(prevErrors => ({ ...prevErrors, [name]: "This field is required." }));
      setIsFormValid(false);
      return false;
    } else if (regexPatterns[name] && !regexPatterns[name].test(value)) {
      setFieldErrors(prevErrors => ({ ...prevErrors, [name]: `Invalid ${name}.` }));
      setIsFormValid(false);
      return false;
    } else {
      setFieldErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
      setIsFormValid(true);
      return true;
    }
  };

  const regexPatterns = {
    EmailID: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    MobileNo: /^\d{10}$/,
    Pincode: /^\d{6}$/
  };

  const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <div className="FormCss">
      <div className="form-container">
        <Form autoComplete="off" className="form-md" style={{ position: "relative" }}>
          {showEmptyFieldsMessage && (
            <p style={{ color: "red", marginBottom: "10px" }}>All fields are required.</p>
          )}

          <div className="form-section">
            <h3 className="mb-3">Basic Information</h3>
            <div className="input-row">
              <div className="form-group">
                <MDBInput
                  label="First Name"
                  type="text"
                  name="Fname"
                  value={formData.Fname}
                  onChange={handleChange}
                  required
                  id="Fname"
                />
                {fieldErrors.Fname && <p style={{ color: "red" }}>{fieldErrors.Fname}</p>}
              </div>
              <div className="form-group">
                <MDBInput
                  label="Last Name"
                  type="text"
                  name="Lname"
                  value={formData.Lname}
                  onChange={handleChange}
                  required
                  id="Lname"
                />
                {fieldErrors.Lname && <p style={{ color: "red" }}>{fieldErrors.Lname}</p>}
              </div>
            </div>
            <div className="input-row">
              <div className="form-group">
                <MDBInput
                  label="Mobile No"
                  type="text"
                  name="MobileNo"
                  value={formData.MobileNo}
                  onChange={handleChange}
                  minLength="10"
                  maxLength="10"
                  required
                  id="MobileNo"
                />
                {fieldErrors.MobileNo && <p style={{ color: "red" }}>{fieldErrors.MobileNo}</p>}
              </div>
              <div className="form-group">
                <MDBInput
                  label="Email ID"
                  type="email"
                  name="EmailID"
                  value={formData.EmailID}
                  onChange={handleChange}
                  required
                  id="EmailID"
                />
                {fieldErrors.EmailID && <p style={{ color: "red" }}>{fieldErrors.EmailID}</p>}
              </div>
            </div>
            <div className="input-row">
              <div className="form-group">
                <DatePicker
                  label="DOB"
                  defaultValue={formData.DOB ? moment(formData.DOB, "DD-MM-YYYY") : null}
                  onChange={handleDateChange}
                  style={{ width: '100%', height: "45px" }}
                  disabledDate={disabledDate}
                />

                {fieldErrors.DOB && <p style={{ color: "red" }}>{fieldErrors.DOB}</p>}
              </div>
              <div className="form-group">
                <Select
                  showSearch
                  placeholder="Gender"
                  value={formData.Gender}
                  onChange={(value) => setFormData(prevData => ({ ...prevData, Gender: value }))}
                  filterOption={filterOption}
                  options={GenderOptions.map((option) => ({
                    label: option.name,
                    value: option.id
                  }))}
                  style={{ width: '100%', height: "45px" }}
                />
                {fieldErrors.Gender && <p style={{ color: "red" }}>{fieldErrors.Gender}</p>}
              </div>
            </div>
            <div className="form-group full-width">
              <MDBTextArea
                label="Address"
                name="Address"
                value={formData.Address}
                onChange={handleChange}
                required
                id="Address"
                ref={AddressInputRef}
                style={{ width: "100%", height: "100px", padding: "10px", resize: "none" }}
              />
              {fieldErrors.Address && <p style={{ color: "red" }}>{fieldErrors.Address}</p>}
            </div>

            <div className="input-row">
              <div className="form-group">
                <Select
                  name="State"
                  value={formData.State}
                  onChange={handleStateChange}
                  onSearch={handleSearchState}
                  options={StateOptions.map(State => ({ value: State.id, label: State.name }))}
                  placeholder="Select State"
                  showSearch
                  filterOption={filterOption}
                  style={{ width: "100%", height: "45px" }}
                />
                {fieldErrors.State && <p style={{ color: "red" }}>{fieldErrors.State}</p>}
              </div>
              <div className="form-group">
                <Select
                  name="City"
                  value={formData.City}
                  onChange={handleCityChange}
                  options={CityOptions.map(City => ({ value: City.id, label: City.name }))}
                  placeholder="Select City"
                  showSearch
                  filterOption={filterOption}
                  style={{ width: "100%", height: "45px" }}
                  disabled={!formData.State}
                />
                {fieldErrors.City && <p style={{ color: "red" }}>{fieldErrors.City}</p>}
              </div>
              <div className="form-group">
                <Select
                  name="Pincode"
                  value={formData.Pincode}
                  onChange={handlePincodeChange}
                  onSearch={handleSearchPincode}
                  options={PincodeOptions.map(Pincode => ({ value: Pincode.id, label: Pincode.pincode }))}
                  placeholder="Select Pincode"
                  showSearch
                  filterOption={filterOption}
                  style={{ width: "100%", height: "45px" }}
                  disabled={!formData.City}
                />
                {fieldErrors.Pincode && <p style={{ color: "red" }}>{fieldErrors.Pincode}</p>}
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default BasicInfoForm;